import { SET_PARAMS, REFRESH_ON, REFRESH_OFF } from "../types/searchType";

// Action Funtions
export const setParams = (data: { [key: string]: any }) => ({
  type: SET_PARAMS,
  payload: data,
});
export const refreshOn = () => ({ type: REFRESH_ON });
export const refreshOff = () => ({ type: REFRESH_OFF });
